class Assets {
  css (path) {
    if (Array.isArray(path)) return path.map(p => this.css(p))
    var css = document.createElement('link')
    css.href = path
    css.type = 'text/css'
    css.rel = 'stylesheet'
    this.load(css)
  }
  script (path) {
    if (Array.isArray(path)) return path.map(p => this.script(p))
    var script = document.createElement('script')
    script.src = path
    this.load(script)
  }
  load (element) {
    document.getElementsByTagName('head')[0].appendChild(element)
  }
}
export default new Assets()



// WEBPACK FOOTER //
// ./src/helpers/assets.js